<!-- 存储中心-充值记录 -->
<!-- 存储中心-充值记录 -->
<template>
    <div class="record">
        <!-- 表格部分 -->
        <div class="table">
            <div class="table-body">
                <el-table :data="tableData" style="width: 100%"
                    :header-cell-style="{ background: '#F5F7FA', color: '#454D53' }">
                    <el-table-column v-for="(item, index) in RechargeLog" :prop="item.prop" :label="item.label"
                        :width="item.width" :show-overflow-tooltip="item.tooltip">
                        <template slot-scope="scope">
                            <!-- <el-popover trigger="hover" placement="top">
                            </el-popover> -->
                            <div v-if="item.prop == 'storage'">{{ scope.row[item.prop] }}GB</div>
                            <div v-else-if="item.prop == 'pay_amount'">{{ scope.row[item.prop] }}元</div>
                            <div v-else-if="item.prop == 'variable_hours'">{{ scope.row[item.prop] }}天</div>
                            <div v-else>{{ scope.row[item.prop] }}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
             <!-- 分页 -->
             <div class="table-footer">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="searchObj.page" :page-sizes="[10, 20, 30, 40]" :page-size="searchObj.page_size"
                    layout="total, sizes, prev, pager, next, jumper" :total="total_count">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { commentData } from '../data'
import apis from '../../api/api'
export default {
    mixins: [commentData],
    data() {
        return {
            searchObj: {// 搜索条件
                page: 1,
                page_size: 10,
            },
            total_count:0,//总条数
            tableData: [],
        }
    },
    mounted() {
        this.getRecord();
    },
    methods: {
        //   /exchange/plan/purchase/record
        getRecord() {// 获取购买记录
            apis.RechargeRecord(this.searchObj).then(res => {
                console.log('RechargeRecord', res)
                this.tableData = res.list;
                this.total_count = res.page_info.total_count;
            })
        },
        // 切换每页条数
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.searchObj.page_size = val;
            this.getRecord()
        },
        // 切换当前页
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.searchObj.page = val;
            this.getRecord();
        },
    },
}
</script>
<style scoped lang="less">
.table-footer {
    display: flex;
    justify-content: center;
    margin-top: 30px;
}
</style>